import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { Provider } from 'react-redux'
import { store } from './redux/store/store'
import { initTheme } from './lib/theme'
import { installToastDedup } from './lib/notify'
import { queryClient } from './lib/queryClient'
import { FinancialPeriodProvider } from './context/FinancialPeriodContext'
import './styles/app.css'
import App from './App'

initTheme()
// Observe every page-level toast so the query client's mutation cache can avoid
// stacking a second, generic toast on top of it.
installToastDedup()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <FinancialPeriodProvider>
            <App />
          </FinancialPeriodProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
  </StrictMode>,
)
